import * as qualificationIcon from 'presentation/assets/images/qualificationsIcons';
import {translations} from 'presentation/translations-new';

const {qualifications} = translations['pt-br'].privateFlow.guideFlow;

export type Qualification = {
	code: number;
	image: string;
	label: string;
	height?: number;
	width?: number;
};

export const QUALIFICATIONS: Qualification[] = [
	{
		code: 1,
		image: qualificationIcon.qlA,
		label: qualifications.A,
	},
	{
		code: 14,
		image: qualificationIcon.qlD,
		label: qualifications.D,
	},
	{
		code: 9,
		image: qualificationIcon.qlE,
		label: qualifications.E,
	},
	{
		code: 12,
		image: qualificationIcon.qlG,
		label: qualifications.G,
	},
	{
		code: 13,
		image: qualificationIcon.qlI,
		label: qualifications.I,
	},
	{
		code: 15,
		image: qualificationIcon.qlM,
		label: qualifications.M,
	},
	{
		code: 6,
		image: qualificationIcon.qlN,
		label: qualifications.N,
	},
	{
		code: 7,
		image: qualificationIcon.qlP,
		label: qualifications.P,
	},
	{
		code: 10,
		image: qualificationIcon.qlQ,
		label: qualifications.Q,
	},
	{
		code: 8,
		image: qualificationIcon.qlR,
		label: qualifications.R,
	},
	{
		code: 16,
		image: qualificationIcon.qlONABronze,
		label: qualifications.ONABronze,
		width: 14,
		height: 20,
	},
	{
		code: 17,
		image: qualificationIcon.qlONASilver,
		label: qualifications.ONASilver,
		width: 18,
		height: 20,
	},
	{
		code: 18,
		image: qualificationIcon.qlONAGold,
		label: qualifications.ONAGold,
		width: 19,
		height: 20,
	},
];
